<template>
  <button
    class="appearance-none border rounded-md bg-gray-100 border-gray-300 hover:bg-gray-200 transition-all duration-200 px-3 py-1 uppercase text-sm tracking-wide"
    @click="$emit('click')"
  >
    {{ label }}
  </button>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: "Try again?",
    },
  },
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/SimpleButton.vue